import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery, useMutation } from '@apollo/client';
import { ME_QUERY, WITHDRAW_USER_MUTATION } from '../../apollo/queries';
import WithdrawalConfirmModal from '../../components/WithdrawalConfirmModal';
import '../css/WithdrawalPage.css';

const WithdrawalPageContent = () => {
    const [step, setStep] = useState(1);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const navigate = useNavigate();
    
    // 현재 사용자 정보 가져오기
    const { data: userData, loading: userLoading } = useQuery(ME_QUERY);
    
    // 탈퇴 뮤테이션
    const [withdrawUser, { loading: withdrawLoading }] = useMutation(WITHDRAW_USER_MUTATION, {
        onCompleted: (data) => {
            setIsModalOpen(false);
            setStep(2);
        },
        onError: (error) => {
            console.error('탈퇴 처리 중 오류:', error);
            alert('탈퇴 처리 중 오류가 발생했습니다. 다시 시도해주세요.');
        }
    });
    
    const userName = userData?.me?.name || "회원";

    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleConfirmWithdrawal = async () => {
        if (!userData?.me?.id) {
            alert('사용자 정보를 불러올 수 없습니다.');
            return;
        }
        
        try {
            await withdrawUser({
                variables: {
                    userId: parseInt(userData.me.id)
                }
            });
        } catch (error) {
            console.error('탈퇴 처리 실패:', error);
        }
    };

    // 로딩 중
    if (userLoading) {
        return (
            <div className="withdrawal-page">
                <div style={{ textAlign: 'center', padding: '50px' }}>
                    <div>사용자 정보를 불러오는 중...</div>
                </div>
            </div>
        );
    }

    const renderStep1 = () => (
        <div className="withdrawal-container">
            <h2 className="withdrawal-title">
                {userName} 님,
                <br />
                회원탈퇴를 신청하기 전에 안내 사항을 꼭 확인해 주세요.
            </h2>
            <div className="withdrawal-info">
                <p>탈퇴 후 회원정보 및 개인형 서비스 이용기록은 모두 삭제됩니다.</p>
                <p>회원정보 및 연락처 등 서비스 이용기록은 모두 삭제되며, 삭제된 데이터는 복구되지 않습니다.</p>
                <p>삭제되는 내용을 확인하시고 필요한 데이터는 미리 백업을 해주세요.</p>
            </div>
            <div className="withdrawal-actions">
                <button className="btn-cancel" onClick={() => navigate(-1)}>취소</button>
                <button 
                    className="btn-withdraw" 
                    onClick={handleOpenModal}
                    disabled={withdrawLoading}
                >
                    {withdrawLoading ? '처리 중...' : '탈퇴'}
                </button>
            </div>
        </div>
    );

    const renderStep2 = () => (
        <div className="withdrawal-container centered">
            <h2 className="withdrawal-title">회원 탈퇴가 완료되었습니다.</h2>
            <p className="withdrawal-info">
                더 좋은 모습으로 찾아뵙겠습니다.
                <br />
                그동안 부스바월드를 이용해주셔서 감사합니다.
            </p>
            <div className="withdrawal-actions">
                <button className="btn-home" onClick={() => navigate('/')}>홈으로 돌아가기</button>
            </div>
        </div>
    );

    return (
        <div className="withdrawal-page">
            <div className="wp-breadcrumb">
                <span>홈</span> &gt; <span>내 정보</span> &gt; <span>My 페이지</span> &gt; <span className="current">회원 탈퇴</span>
            </div>
            {step === 1 ? renderStep1() : renderStep2()}
            <WithdrawalConfirmModal
                isOpen={isModalOpen}
                onClose={handleCloseModal}
                onConfirm={handleConfirmWithdrawal}
            />
        </div>
    );
};

const WithdrawalPage = () => {
    return (
        <WithdrawalPageContent />
    );
};

export default WithdrawalPage; 